import React, {useEffect, useState} from 'react';
import {
    Create,
    TabbedForm,
    FormTab,
    TextInput,
    required,
    BooleanInput,
    NumberInput,
    ReferenceInput,
    AutocompleteInput,
    FormDataConsumer,
    DateInput,
    SelectInput,
    useDataProvider
} from 'react-admin';
import Grid from '@mui/material/Grid';
import { useForm } from 'react-final-form';
import { CampaignNameInput } from "./CampaignNameInput";

const defaultValue = {
    out_of_home_campaign_type: '/api/out-of-home-campaign-types/1ab3e261-9937-11f0-a097-aeaa295b9a5a',
};

const SanitizedContainer = ({basePath, ...props}) => {
    return (
        <Grid {...props} />
    );
};

export const OutOfHomeCampaignCreate = (props) => {
    const dataProvider = useDataProvider();
    const [selectedData, setSelectedData] = useState(null);

    const handleOnChange = async (e) => {

        if(e) {
            const response = await dataProvider.getOne('outmoove-campaigns', { id: e });
            if(response && response.data) {
                setSelectedData(response.data);
            }
        }
    };

    const transform = (data) => ({
        ...data,
        ready: data.campaign_type === '/api/out-of-home-campaign-types/1ab3e261-9937-11f0-a097-aeaa295b9a5a'
    });

    return (

        <Create {...props} transform={transform}>

            <TabbedForm redirect="list" initialValues={defaultValue}>
                 <FormTab label="Settings">
                    <SanitizedContainer container spacing={1} style={{width: "100%"}}>

                    <Grid item xl={6}>

                        <ReferenceInput
                            label="Type"
                            source="campaign_type"
                            reference="out-of-home-campaign-types"
                            sort={{ field: 'type', order: 'ASC' }}
                            validate={required()}
                        >
                            <SelectInput optionText="type" translateChoice={false} />
                        </ReferenceInput>

                        <FormDataConsumer>
                            {({ formData, ...rest }) => {

                                const form = useForm();

                                useEffect(() => {
                                    if(selectedData && form) {
                                        form.change('start_date', selectedData.start_date);
                                        form.change('end_date', selectedData.end_date);
                                        form.change('name', selectedData.advertiser_campaign);
                                    }
                                }, [selectedData, form]);

                                const showLocationListFields = formData.campaign_type === '/api/out-of-home-campaign-types/1ab39f58-9937-11f0-a097-aeaa295b9a5a';
                                const showOutMooveFields = formData.campaign_type === '/api/out-of-home-campaign-types/1ab3e261-9937-11f0-a097-aeaa295b9a5a';

                                return (
                                    <>
                                        {showLocationListFields && (
                                            <>
                                                <CampaignNameInput  validate={ required() } />
                                                <NumberInput source="week_number" label="Week number" />
                                                <BooleanInput source="location_list_only" label="Location list only" />
                                                <NumberInput source="max_random_locations" label="Max. random locations" />
                                            </>
                                        )}

                                        {showOutMooveFields && (
                                            <>
                                                <ReferenceInput perPage={10000} label="Outmoove Campaign" source="outmoove_campaign"
                                                                reference="outmoove-campaigns" validate={required()}
                                                                filterToQuery={advertiser_campaign => ({advertiserCampaign: advertiser_campaign})} >
                                                    <AutocompleteInput debounce={500} optionText="advertiser_campaign" translateChoice={false} />
                                                </ReferenceInput>

                                                <CampaignNameInput  validate={ required() } />
                                                <NumberInput source="week_number" label="Week number" />
                                                <DateInput source="start_date" label="Start date" />
                                                <DateInput source="end_date" label="End date" />
                                            </>
                                        )}
                                    </>
                                );
                            }}

                        </FormDataConsumer>
                        <TextInput multiline source="client_email" label="Client email (one per line)" />
                    </Grid>
                </SanitizedContainer>
            </FormTab>
        </TabbedForm>
    </Create>);

};